import Index from "./Index.vue"
import Open from "./Open.vue"

export default {
  routes: [
    {
      path: "/",
      component: Index
    },
    {
      path: "/open/:bargainId/:offerId",
      component: Open
    },
    {
      path: "/open/:bargainId",
      component: Open
    },
    {
      path: "*",
      component: Index
    }
  ]
}
